module.exports = __webpack_public_path__ + "static/media/icomoon.c890f724.woff";